<template>
  <div
    class="panel-block shopping-list--entry"
    v-bind:class="{
      'shopping-list--entry__is-shopped': entry.isShopped,
    }"
  >
    <label class="checkbox">
      <input
        type="checkbox"
        v-bind:checked="entry.isShopped"
        v-on:click="toggleChecked(entry)"
      />
      {{ entry.ingredient.name
      }}<span
        v-if="entry.ingredient.amount"
        class="shopping-list--entry--amount"
        >, {{ entry.ingredient.amount }}{{ entry.ingredient.unit }}</span
      >
      <span v-if="entry.recipe" class="shopping-list--entry--recipe">
        ({{ $t("for") }} {{ entry.recipe.name }})
      </span>
    </label>
    <DropdownMenu class="is-right shopping-list--entry--actions-menu">
      <div
        class="shopping-list--entry--actions-menu--shops-section"
        v-if="Array.isArray(allShops) && allShops.length"
      >
        <div
          v-if="!displayAllShops"
          class="shopping-list--entry--actions-menu--shops-section--favorite-shops"
        >
          <a
            class="dropdown-item shopping-list--entry--move-button"
            v-for="shop in favoriteShops"
            :key="shop._id"
            @click="moveEntryToShop(entry, shop)"
            >→ {{ shop.name }}</a
          >
          <a
            @click.stop="showMoreShops"
            class="dropdown-item shopping-list--entry--more-shops-button"
            >{{ $t("show-more-shops") }}</a
          >
        </div>
        <div
          v-if="displayAllShops"
          class="shopping-list--entry--actions-menu--shops-section--all-shops"
        >
          <a
            class="dropdown-item shopping-list--entry--move-button"
            v-for="shop in allShops"
            :key="shop._id"
            @click="moveEntryToShop(entry, shop)"
            >→ {{ shop.name }}</a
          >
        </div>
        <hr class="dropdown-divider" />
      </div>
      <a
        @click="deleteEntry(entry)"
        class="dropdown-item shopping-list--entry--delete-button"
        :title="$t('Delete')"
      >
        {{ $t("Delete") }}
      </a>
    </DropdownMenu>
  </div>
</template>

<script>
import Vue from "vue";
import DropdownMenu from "@/components/DropdownMenu.vue";

export default Vue.extend({
  name: "ShoppingListEntry",
  props: ["entry", "allShops", "favoriteShops"],
  data() {
    return {
      displayAllShops: !(this.favoriteShops && this.favoriteShops.length),
    };
  },
  methods: {
    toggleChecked(entry) {
      this.$store.dispatch("toggleShoppingListEntryIsShopped", entry);
    },
    deleteEntry(entry) {
      this.$store.dispatch("removeShoppingListEntry", entry);
    },
    moveEntryToShop(entry, shop) {
      this.$store.dispatch("moveShoppingListEntryToShop", { entry, shop });
    },
    showMoreShops() {
      this.displayAllShops = true;
    },
  },
  computed: {},
  components: {
    DropdownMenu,
  },
});
</script>

<style scoped>
.shopping-list--entry--amount {
  color: grey;
}

.shopping-list--entry--recipe {
  color: grey;
  margin-left: 0.1em;
}

.shopping-list--entry__is-shopped label {
  text-decoration: line-through;
}

.shopping-list--entry--actions-menu {
  margin-left: auto;
}

a.shopping-list--entry--move-button {
  overflow: hidden;
  text-overflow: ellipsis;
}

@media print {
  .shopping-list--entry {
    border: none;
  }

  .shopping-list--entry input {
    display: none;
  }

  .shopping-list--entry::before {
    content: "☐";
    margin-right: 0.3em;
  }

  .shopping-list--entry__is-shopped::before {
    content: "☑";
  }

  .dropdown {
    display: none;
  }
}
</style>
<i18n>
{
  "en": {
    "Move entry to": "Move entry to {shop}",
    "show-more-shops": "Show more…",
    "tutorials": {
      "list": "You can add as many entries as you like. Check them off whenever you bought an item. Checked-off entries will disappear automatically the next day.",
      "createRecipes": "You can enter your favorite {0} in order to save time."
    }
  },
  "de": {
    "for": "für",
    "Your shopping list is empty.": "Die Einkaufsliste ist leer.",
    "Delete": "Löschen",
    "Here you check off your shopped items.": "Hier hakst du die Dinge ab.",
    "Move entry to": "Verschieben zu {shop}",
    "show-more-shops": "Mehr…",
    "Recipes": "Rezepte",
    "tutorials": {
      "list":"Du kannst beliebig viele Einträge hinzufügen. Hake sie ab, wenn du sie gekauft hast. Die erledigten Einträge verschwinden am nächsten Tag automatisch.",
      "createRecipes": "Trage deine {0} ein, um die Zutaten schneller hinzuzufügen."
    }
  }
}
</i18n>
